// src/App.js
import { Route, Routes } from 'react-router-dom';

// User Components
import Home from './components/Home';
import DomesticTours from './components/DomesticTours';
import InternationalTours from './components/InternationalTours';
import Navbar from './components/Navbar';
import AboutUs from './components/AboutUs';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import ContactUs from './components/ContactUs';

// User/Auth Pages
import UserLogic from './pages/UserLogic';
import Register from './pages/Register';

// Admin Components
import HomeAdmin from './pages/HomeAdmin';
import AddDomesticTour from './pages/AddDomasticTour';
import AddInternationalTour from './pages/AddInternationalTour';
import AddGallery from './pages/AddGallery';
import AddTestimonials from './pages/AddTestimonials';
import AddFooter from './pages/AddFooter';
import AdminLayout from './components/AdminLayout';
import AddAboutUs from './pages/AddAboutUs';

function App() {
  return (
    <Routes>
      {/* 🌐 Public/User Routes */}
      <Route path="/" element={<><Navbar /><Home /></>} />
      <Route path="/domestic-tours" element={<><Navbar /><DomesticTours /></>} />
      <Route path="/International-tours" element={<><Navbar /><InternationalTours /></>} />
      <Route path="/AboutUs" element={<><Navbar /><AboutUs /></>} />
      <Route path="/gallery" element={<><Navbar /><Gallery /></>} />
      <Route path="/testimonials" element={<><Navbar /><Testimonials /></>} />
      <Route path="/Contact-us" element={<><Navbar /><ContactUs /></>} />
      <Route path="/user-login" element={<UserLogic />} />


      {/* 🛠️ Admin Dashboard with Sidebar Layout */}
      <Route path="/" element={<AdminLayout />}>
        <Route path="Admin-home" element={<HomeAdmin />} />
        <Route path="addDomastic-tour" element={<AddDomesticTour />} />
        <Route path="AddInternational-Tour" element={<AddInternationalTour />} />
        <Route path="AddGallery" element={<AddGallery />} />
        <Route path="AddTestimonials" element={<AddTestimonials />} />
        <Route path="AddAboutUs" element={<AddAboutUs />} />
        <Route path="AddFooter" element={<AddFooter />} />
        <Route path="/register" element={<Register />} />
      </Route>
    </Routes>
  );
}

export default App;
